<template>
  <div
    id="agent-shopping-basket"
    class="has-background-dark-red"
    v-if="observationsFilterIsActive"
  >
    <button
      id="clear-button"
      class="level-item button btn-secondary"
      @click.stop="clearObservations"
    >
      Clear results
    </button>
    <div
      id="agent-shopping-basket-heading-container"
      class="level is-padded-small"
      role="button"
      @click="toggleShoppingBasket"
    >
      <div class="level-item has-text-white">
        <font-awesome-icon
          :icon="icon"
          size="3x"
        />
        <span
          id="shopping-basket-heading"
          class="is-size-4"
        >{{ headingText }}
          <loading-spinner
            class="is-inline"
            size="1x"
            v-if="loadingAgents"
          />
        </span>
        <font-awesome-icon
          :icon="icon"
          size="3x"
        />
      </div>
    </div>
    <b-column
      v-if="isOpen"
      class="is-full"
    >
      <observation-tag-bar />
    </b-column>
    <observation-result-basket-list
      v-if="isOpen"
      :agents="matchingAgentsSortedByType"
      @list-item-clicked="toggleShoppingBasket"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ObservationResultBasketList from './ObservationResultBasketList'
import ObservationTagBar from '@/components/observations/ObservationTagBar'
import { CLEAR_OBSERVATIONS } from '@/store/mutation-types'

export default {
  components: {
    ObservationResultBasketList,
    ObservationTagBar
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters(['observationsFilterIsActive',
      'loadingAgents',
      'matchingAgents',
      'matchingAgentsSortedByType']),
    headingText () {
      if (this.loadingAgents) {
        return 'Loading'
      }
      if (this.isOpen) {
        return `Click to hide results (${this.matchingAgents.length})`
      }
      return `Click to see results (${this.matchingAgents.length})`
    },
    icon () {
      return this.isOpen ? 'caret-down' : 'caret-up'
    }
  },
  methods: {
    ...mapMutations([CLEAR_OBSERVATIONS]),
    toggleShoppingBasket () {
      this.isOpen = !this.isOpen
    },
    clearObservations () {
      this.isOpen = false
      this.CLEAR_OBSERVATIONS()
    }
  },
  watch: {
    observationsFilterIsActive (newVal) {
      if (newVal === false) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/colorpallet.scss";
@import "../../assets/layout-utils.scss";

#agent-shopping-basket {
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  min-height: $result-basket-min-height;
  max-height: 75%;
  display: flex;
  flex-direction: column;

  #agent-shopping-basket-heading-container {
    // Hack to stretch full page width
    margin-left: -50%;
    margin-right: -50%;
  }

  #shopping-basket-heading {
    margin-left: 20px;
    margin-right: 20px;
  }

  #clear-button {
    border-radius: 0px;
    border: 0.5px solid $white;
    background-color: $dark-red;
    color: $white;
    top: 10px;
    position: absolute;
    height: 50px;
    left: 10%;
    z-index: 1;
    @include mobile {
      top: -50px !important;
      left: 0px !important;
    }
  }
}
</style>
